import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { VirtualScrollModule } from 'angular2-virtual-scroll';
import { ToastrModule } from 'ngx-toastr';

import { UserService } from '../user.service';
import { ActivationModalComponent } from './activation-modal/activation-modal.component';
import { ActivationModalService } from './activation-modal/activation-modal.service';
import { ActivationComponent } from './activation/activation.component';
import { DefaultImageDirective } from './directive/defaultImage.directive';
import { LoginModalService } from './login/login-modal.service';
import { LoginModalComponent } from './login/login.component';
import { MaterialModule } from './material/material.module';
import { ApplyPopupComponent } from './narwhal-card/apply-popup/apply-popup.component';
import { BuyPopupComponent } from './narwhal-card/buy-popup/buy-popup.component';
import { NarwhalCardComponent } from './narwhal-card/narwhal-card.component';
import { NarwhalSellPopupComponent } from './narwhal-card/narwhal-sell-popup/narwhal-sell-popup.component';
import { NarwhalImageGenComponent } from './narwhal-image-gen/narwhal-image-gen.component';
import { ShortNumberPipe } from './pipe/short-number.pipe';
import { BowserModule } from 'ngx-bowser';
import { MetaMaskPopupComponent } from './meta-mask-popup/meta-mask-popup.component';

export function getTooltipConfig() {
  return Object.assign(new NgbTooltipConfig(), { placement: 'bottom', container: 'body' });
}

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    NgbTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-center',
      messageClass: 'toast-msg',
      disableTimeOut: true,
      preventDuplicates: true
    }),
    VirtualScrollModule,
    BowserModule
  ],
  declarations: [
    LoginModalComponent,
    NarwhalCardComponent,
    NarwhalImageGenComponent,
    BuyPopupComponent,
    NarwhalSellPopupComponent,
    ActivationComponent,
    ActivationModalComponent,
    DefaultImageDirective,
    ApplyPopupComponent,
    ShortNumberPipe,
    MetaMaskPopupComponent
  ],
  entryComponents: [LoginModalComponent, ActivationModalComponent],
  providers: [UserService, LoginModalService, ActivationModalService, { provide: NgbTooltipConfig, useFactory: getTooltipConfig }],
  exports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    VirtualScrollModule,
    LoginModalComponent,
    TranslateModule,
    ToastrModule,
    NarwhalCardComponent,
    BuyPopupComponent,
    NarwhalSellPopupComponent,
    ActivationComponent,
    ActivationModalComponent,
    DefaultImageDirective,
    ShortNumberPipe,
    NgbTooltipModule
  ]
})
export class SharedModule {}
